import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core"

export type CustomChipInfoProps = {
  label: string
  labelKey?: string
  icon: IconProp
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning"
  borderColor?: any
}

export interface ChipInfoIconProps {
  iconSize?: SizeProp
  type: ChipInfoStatusEnum
  custom?: CustomChipInfoProps
}

export enum ChipInfoStatusEnum {
  None = "None",
  New = "New",
  Planned = "Planned",
  Assigned = "Assigned",
  Sent = "Sent",
  Booked = "Booked",
  Resolved = "Resolved",
  Completed = "Completed",
  Declined = "Declined",
  Active = "Active",
  NotPassed = "NotPassed",
  Passed = "Passed",
  NotStarted = "NotStarted",
  Unmanaged = "Unmanaged",
  OnGoing = "OnGoing",
}
